import { State2Way } from "@/decorators";
import moment from "moment-timezone";
import { cloneDeep, sumBy } from "lodash";
import { Apollo } from "@/decorators";
import { mathFix } from "../services/mathServices";

// import ConvertFEC from "../services/importFecService"
import ImportFecFront from "../services/importFecFront";
import { createCompany } from "../services/companyServices";
import { isInsideClosedAccountingPeriod } from "../services/accountingPeriods";
import companyTable from "./admin/CompaniesTable.vue";
import { AccountingItemBase } from "./AccountingItemBase";
import AccountableAccount from "./AccountableAccount.vue";
import FreeTag from "./tag/FreeTag.vue";
import OssDataTable from "./ossComponents/ossDataTable2.vue";

import UPDATE_ACCOUNTINGLINE_DUEDATE from "../graphql/accountingLine/UpdateAccountingLineDueDate.gql";
// import UPSERT_AUDIT_CHECK_RESULT from "../graphql/audit/UpsertAuditCheckResultClosure.gql";
import ACCOUNTABLE_ACCOUNTS_FROM_TPC from "../graphql/AccountableAccountsFromThirdPartyCompany.gql";
import VAT_DECLARATION_LAST from "../graphql/vatDeclaration/VATDeclarationLast.gql";

import { getDBFormattedDate } from "../services/dateServices";
import { Component } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

import emitter from "./accounting/accountingLines.emits";

@Component({
    components: {
        companyTable,
        AccountableAccount,
        FreeTag,
        OssDataTable,
    },
    emits: [
        "dueDateChanged",
        "upsert",
        "upsertedAuditCheckResult",
        "item-is-valid",
        "item-is-not-valid",
        "closeDialog",
        "add-item",
        "remove-item",
        "input",
    ],
})
export class AccountingItemEditionBase2 extends AccountingItemBase {
    @Model() value: boolean;
    @Prop({ default: "" }) acKey: string;
    @Prop({ default: null }) auditCheckResult: any;
    @Prop({ default: "" }) accountingPeriodId: string;
    @Prop() editionIndex: number;

    @State2Way("updateAccountableAccountTable", "accountableAccountTable")
    accountableAccountTable;

    formIsValid: boolean = true;
    autoCompletion: boolean = this.defaultAutoCompletion || false;

    duplicateAccountingTransaction: boolean = false;

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    loadingAddAccountingPeriod: boolean = false;
    dialogAddAccountingPeriod = false;
    dialogSelectCompany: boolean = false;
    selectedRow = null;
    selectedRowIndex = null;

    get activateTagguing() {
        return true;
    }

    get isEdition() {
        return true;
    }

    needCu(al) {
        return (
            al?.accountableAccount?.name &&
            (al.accountableAccount.name.startsWith("411") ||
                al.accountableAccount.name.startsWith("491"))
        );
    }

    setThirdParty(data) {
        this.selectedRow.thirdPartyCompany = data;
    }

    // get needCustomer() {
    //     return this._needCustomer(this.selectedRow)
    // }

    needsThirdPartyCompany(al) {
        if (al?.accountableAccount?.name) {
            const dbAA = this.accountableAccountTable?.accountableAccounts.find(
                (aa) => aa.name === al.accountableAccount.name,
            );
            return dbAA?.thirdPartyCompany;
        }
        return false;
    }

    needsUser(al) {
        if (al?.accountableAccount?.name) {
            const dbAA = this.accountableAccountTable?.accountableAccounts.find(
                (aa) => aa.name === al.accountableAccount.name,
            );
            return dbAA?.user;
        }
        return false;
    }

    needsBankAccount(al) {
        if (al?.accountableAccount?.name) {
            const dbAA = this.accountableAccountTable?.accountableAccounts.find(
                (aa) => aa.name === al.accountableAccount.name,
            );
            return dbAA?.bankAccount;
        }
        return false;
    }
    // get needSupplier() {
    //     return this._needSupplier(this.selectedRow)
    // }
    // get needCompany() {
    //     for (const al of this.accountingLines) {
    //         if (this._needCustomer(al)|| this._needSupplier(al)) return true
    //     }
    //     return false
    // }
    // purchaseVats = {
    //     445662: { name: "445200", description: "TVA déductible sur acquisition intracommunautaires" },
    //     445630: { name: "445730", description: "T.V.A. due Import" },
    //     445680: { name: "445780", description: "Taxes assimilées à la T.V.A. due Autoliquidation" }
    // }
    // dicoNetAmount = {
    //     445702: true,
    //     445705: true,
    //     445710: true,
    //     445720: true,
    // }

    get containsThirdPartyCompanies() {
        for (const row of this.accountingLines) {
            if (row.thirdPartyCompany && row.thirdPartyCompany.name) {
                return true;
            }
        }
        return false;
    }

    aaTitle(aa) {
        return aa.name + " - " + aa.description;
    }

    async onDueDateChanged(al: any, dueDate: any) {
        if (al && dueDate !== undefined) {
            al.dueDate = dueDate;
            if (this.readonly) {
                await this.$apollo.mutate({
                    mutation: UPDATE_ACCOUNTINGLINE_DUEDATE,
                    variables: {
                        accountingLineId: al.id,
                        dueDate: dueDate ? getDBFormattedDate(dueDate) : null,
                    },
                });
            }
        } else {
            console.error("onDueDateChanged wrong input");
        }
        // this.$emit("dueDateChanged", al);
    }

    get accountableAccounts() {
        if (this.accountableAccountTable?.accountableAccounts) {
            return this.accountableAccountTable?.accountableAccounts.filter(
                (aa) => aa.name.length >= 6,
            );
        }
        return [];
    }

    dicoTypeAAs = {
        PURCHASE_INVOICE: "401000",
        SALES_INVOICE: "411000",
        EXPENSE_REPORT: "425000",
        CURRENT_ACCOUNT: "455000",
    };

    getAccountableAccount(type: string): string {
        const rootAA = this.dicoTypeAAs[type];
        if (rootAA) {
            return this.accountableAccounts.find((aa) => aa.name?.startsWith(rootAA));
        }
        return "";
    }

    onItemDebitChanged(item) {
        if (item.debit) {
            item.debit = mathFix(item.debit, 2);
            item.credit = 0.0;
        }
        // if ((this.totalCredit - this.totalDebit) !== 0) {
        //     this.addRowIfNecessary()
        // }
        // if (item.subItem) {
        //     item.subItem.debit = item.credit
        //     item.subItem.credit = item.debit
        // }
    }

    onItemCreditChanged(item) {
        if (item.credit) {
            item.credit = mathFix(item.credit, 2);
            item.debit = 0.0;
        }
        // if ((this.totalCredit - this.totalDebit) !== 0) {
        //     this.addRowIfNecessary()
        // }
        // if (item.subItem) {
        //     item.subItem.debit = item.credit
        //     item.subItem.credit = item.debit
        // }
    }
    // showNetAmount(item) {
    //     if (item.accountableAccount && item.accountableAccount.name) {
    //         return this.dicoNetAmount[item.accountableAccount.name]
    //     }
    //     return false;
    // }

    // @Watch("generalWording")
    // onGeneralWordingChanged(value, prevValue) {
    //     // if (prevValue) {
    //     if (this.accountingLines) {
    //         const prevValueLC = prevValue.toLowerCase()
    //         for (const row of this.accountingLines) {
    //             if (row.wording.toLowerCase() === prevValueLC) {
    //                 row.wording = value
    //             }
    //         }
    //     }
    //     // } else {
    //     //     for (const row of this.accountingLines) {
    //     //         row.wording = value
    //     //     }
    //     // }
    // }

    replace(text, prevValue, newValue) {
        const index = this.generalWording.indexOf(prevValue);
        if (index !== -1) {
            let newText = text.substring(0, index);
            newText += newValue;
            newText += text.substring(index + prevValue.length);
            return newText;
        }
        return text;
    }

    @Watch("date")
    onDateChanged(value, prevValue) {
        if (value !== prevValue) {
            if (value !== "" && moment(value).isValid() && moment(this.lastValidDate).isValid()) {
                let lastValidDate = moment(this.lastValidDate).format("YYYY-MM-DD");
                if (this.accountingLines.length) {
                    for (const row of this.accountingLines) {
                        const alDate = moment(row.date).format("YYYY-MM-DD");
                        if (alDate === lastValidDate) {
                            row.date = value;
                        }
                    }
                }

                lastValidDate = moment(this.lastValidDate).format("DD/MM/YYYY");
                const formatedValue = moment(value).format("DD/MM/YYYY");
                const newText = this.replace(this.generalWording, lastValidDate, formatedValue);
                if (newText !== this.generalWording) {
                    this.generalWording = newText;
                }
                this.lastValidDate = value;
            }
        }
    }

    @Watch("typeTitle")
    onTypeTitleChanged(value, prevValue) {
        if (value !== prevValue) {
            const newText = this.replace(this.generalWording, prevValue, value);
            if (newText !== this.generalWording) {
                this.generalWording = newText;
            }
        }
    }

    onItemWordingChanged(item) {
        item.wording = item.wording;
    }

    addRowIfNecessary() {
        const realRows = this.accountingLines?.filter(
            (r) => r.accountableAccount?.name?.length >= 6,
        );
        const difference = mathFix(
            sumBy(realRows, (r) => r.debit - r.credit),
            2,
        );
        const differenceRow = this.accountingLines?.find(
            (r) => r.accountableAccount?.name?.length < 6,
        );
        if (differenceRow) {
            if (difference) {
                differenceRow.debit = difference < 0 ? Math.abs(difference) : 0;
                differenceRow.credit = difference > 0 ? difference : 0;
            } else {
                this.deleteRow(differenceRow);
            }
        } else {
            if (difference !== 0) {
                this.addRow(difference);
            }
        }
    }

    addRow(difference = 0) {
        const row = JSON.parse(JSON.stringify(this.defaultRows[0]));
        row.date = this.date;
        row.wording = this.accountingLines.length
            ? this.accountingLines[this.accountingLines.length - 1].wording
            : this.generalWording;
        if (difference > 0) {
            row.credit = mathFix(difference, 2);
        } else if (difference < 0) {
            row.debit = mathFix(Math.abs(difference), 2);
        }

        this.accountingLines.push(row);
    }

    deleteRow(item) {
        const index = this.accountingLines.findIndex((r) => r === item);
        if (index !== -1) {
            this.accountingLines.splice(index, 1);
        }
    }

    onThirdPartyCompany(item, index) {
        this.selectedRow = item;
        this.selectedRowIndex = index;
        this.dialogSelectCompany = true;
    }

    get addQuantityColumn() {
        for (const row of this.accountingLines) {
            if (row.stockOperation?.stockProduct?.id) {
                return true;
            }
        }
        return false;
    }

    get additionalQuantityColumns() {
        const maxQuantitiesLength = this.accountingLines.reduce((max, item) => {
            return Math.max(max, item.stockOperation?.stockProduct?.data?.quantities?.length || 0);
        }, 0);
        return maxQuantitiesLength > 0;
    }

    addItem(row, index, dicoAccountingItems, convertFec) {
        const stockOperation = row.stockOperation || undefined;
        const itemRow = {
            prevAccountingLineId: row.id || undefined,
            id: 0,
            index: index,
            type: this.type,
            wording: row.wording || this.generalWording,
            stockOperation,
            accountableAccount: row.accountableAccount.name,
            thirdPartyCompanyId:
                row.thirdPartyCompany && row.thirdPartyCompany.id
                    ? row.thirdPartyCompany.id
                    : undefined,
            userId: row.user && row.user.id ? row.user.id : undefined,
            bankAccountId: row.bankAccount && row.bankAccount.id ? row.bankAccount.id : undefined,
            date: moment(this.date).format("YYYYMMDD"),
            dueDate: row.dueDate ? moment(row.dueDate).format("YYYYMMDD") : undefined,
            debit: row.debit.toString(),
            credit: row.credit.toString(),
            reconciliation: 0,
            result: {
                netAmount: 0.0,
                debit: 0.0,
                credit: 0.0,
            },
            otherAttributes: {},
            isBankTransaction: row.isBankTransaction,
            tags: row.tags,
        };
        const accountingItem = convertFec.addRowToAccountingItem(dicoAccountingItems, itemRow);
        if (!this.duplicateAccountingTransaction) {
            if (this.documentId && !accountingItem.documentId) {
                accountingItem.documentId = this.documentId;
            }
            if (this.bankTransactionId && !accountingItem.bankTransactionId) {
                accountingItem.bankTransactionId = this.bankTransactionId;
            }
        }
        convertFec.analyseRowErrors(accountingItem, itemRow);
    }

    async valid() {
        this.loadingValidate = true;
        const convertFec = new ImportFecFront(this.companyId, this.$apollo, false); // v2 add this.companyId
        const dicoCompanyId = {};

        for (const al of this.accountingLines) {
            if (al.tag) {
                continue;
            }
            if (al.thirdPartyCompany && al.thirdPartyCompany.name && !al.thirdPartyCompany.id) {
                const companyName = al.thirdPartyCompany.name.toLowerCase();
                if (dicoCompanyId[companyName]) {
                    al.thirdPartyCompany.id = dicoCompanyId[companyName];
                } else {
                    // eslint-disable-next-line no-await-in-loop
                    const companyId = await createCompany(this.$apollo, al.thirdPartyCompany);
                    dicoCompanyId[companyName] = companyId;
                    al.thirdPartyCompany.id = companyId;
                }
            }
            al.wording ||= this.generalWording;
        }

        const dicoAccountingItems = {};
        let index = 0.0;
        for (const al of this.accountingLines) {
            if (al.tag) {
                continue;
            }
            this.addItem(al, index, dicoAccountingItems, convertFec);
            index++;
        }

        for (const id in dicoAccountingItems) {
            if (id !== undefined) {
                const accountingItem = dicoAccountingItems[id];
                accountingItem.itemReference = this.invoiceNumber;
                accountingItem.wording = this.generalWording;
                accountingItem.tags = this.tags;
                accountingItem.dueDate = this.dueDate;
                convertFec.analyseAccountingItem(accountingItem);
            }
        }
        if (!convertFec.isValid()) {
            // convertFec.isValid()

            return;
        }

        const result = await convertFec.import(this.companyId, false);

        if (this.duplicateAccountingTransaction && result.output?.documents?.[0]) {
            if (!this.onAccountingLinesPage) {
                this.$router.push({
                    name: "document",
                    params: { companyId: this.companyId, id: result.output.documents[0] },
                });
            }
        } else {
            if (!this.onAccountingLinesPage) {
                this.initialize();
                this.$emit("upsert", result);
                this.dialog = false;
                this.refresh();
            }
        }
    }

    // setThirdPartyCompany() {
    //     this.dialogSelectCompany = false;
    // }
    // cancelThirdPartyCompany() {
    //     if (this.selectedRow) {
    //         this.selectedRow.thirdPartyCompany = JSON.parse(JSON.stringify(this.emptyCompany))
    //     }
    //     this.dialogSelectCompany = false;
    // }

    get totalDebit() {
        let total = 0.0;
        for (const row of this.accountingLines) {
            if (row.tag) {
                continue;
            }
            total += row.debit;
        }
        return mathFix(total);
    }

    get totalCredit() {
        let total = 0.0;
        for (const row of this.accountingLines) {
            if (row.tag) {
                continue;
            }
            total += row.credit;
        }
        return mathFix(total);
    }

    get totalDiff() {
        return mathFix(Math.abs(this.totalDebit - this.totalCredit));
    }

    get isBalanced(): boolean {
        if (this.onAccountingLinesPage) {
            if (this.totalDebit > 0 && this.totalDiff === 0 && !this.disabledValidation) {
                this.$emit("item-is-valid", this.autoCompletion, this.type, this.date);
                return true;
            }
            this.$emit("item-is-not-valid");
            return false;
        }
        this.$emit("item-is-not-valid");
        return false;
    }

    checkRow(row) {
        if (!row.accountableAccount?.name) return true;
        if (row.debit < 0) return true;
        if (row.credit < 0) return true;
        if (!row.credit && !row.debit) return true;
        if (
            this.needsThirdPartyCompany(row) &&
            (!row.thirdPartyCompany || !row.thirdPartyCompany.name)
        )
            return true;
        if (this.needsUser(row) && (!row.user || !row.user.id)) return true;
        if (this.needsBankAccount(row) && (!row.bankAccount || !row.bankAccount.id)) return true;
        return false;
    }

    getDisabledValidation() {
        return this.disabledValidation;
    }

    async onAccountableAccountChanged(index) {
        if (this.autoCompletion) {
            if (
                (this.type === "PURCHASE_INVOICE" || this.type === "SALES_INVOICE") &&
                index === 0
            ) {
                if (
                    this.accountingLines.length >=
                    2 /*&& !this.accountingLines[1].accountableAccount?.name*/
                ) {
                    const firstAl = this.accountingLines[0];
                    if (
                        (firstAl.accountableAccount?.name.startsWith("401") ||
                            firstAl.accountableAccount?.name.startsWith("411")) &&
                        firstAl.thirdPartyCompany?.id
                    ) {
                        const res: any = await this.$apollo.query({
                            query: ACCOUNTABLE_ACCOUNTS_FROM_TPC,
                            fetchPolicy: "network-only",
                            variables: {
                                documentType: this.type,
                                companyId: this.selectedCompany.id,
                                thirdPartyCompanyId: firstAl.thirdPartyCompany.id,
                            },
                        });
                        if (
                            res &&
                            res.data &&
                            res.data.accountableAccountsFromThirdPartyCompany?.accountableAccounts
                        ) {
                            const accountableAccounts =
                                res.data.accountableAccountsFromThirdPartyCompany
                                    .accountableAccounts;
                            if (accountableAccounts.length) {
                                let count =
                                    this.accountingLines.length - 1 <= accountableAccounts.length
                                        ? this.accountingLines.length - 1
                                        : accountableAccounts.length;
                                let i = 0;
                                for (; i < count; i++) {
                                    const al = this.accountingLines[i + 1];
                                    al.accountableAccount = accountableAccounts[i];
                                }
                                if (accountableAccounts.length > this.accountingLines.length - 1) {
                                    for (; i < accountableAccounts.length; i++) {
                                        this.addEmptyAL(accountableAccounts[i]);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    onLineAmountSignedChanged(index) {
        if (this.autoCompletion) {
            if (this.accountingLines.length === 3 && index < 2) {
                let total = 0;
                for (let i = 0; i < this.accountingLines.length - 1; i++) {
                    const al = this.accountingLines[i];
                    total += al.debit - al.credit;
                }
                const last = this.accountingLines[this.accountingLines.length - 1];
                total = -total;
                last.debit = total > 0 ? total : 0;
                last.credit = total < 0 ? -total : 0;
                // if (this.type === "PURCHASE_INVOICE" || this.type === "SALES_INVOICE") {
                // }
            }
        }
        this.getDisabledValidation();
    }

    get disabledValidation() {
        if (!this.formIsValid) {
            return true;
        }
        let count = 0;
        if (this.date && isInsideClosedAccountingPeriod(this.$store, this.date)) {
            return true;
        }
        for (const al of this.accountingLines) {
            if (this.checkRow(al)) {
                return true;
            }
            if (!al.tag) {
                count++;
            }
        }
        if (count < 2) {
            return true;
        }
        let aa512Count = 0;
        for (const al of this.accountingLines) {
            if (al.accountableAccount?.name?.startsWith("512")) {
                aa512Count++;
            }
        }
        if (this.log === "BANK_TRANSACTION") {
            if (aa512Count !== 1) {
                return true;
            }
        } else {
            if (aa512Count) {
                return true;
            }
        }

        // if (!this.mandatoryAAFound) return true;
        if (mathFix(this.totalDebit, 2) - mathFix(this.totalCredit, 2)) return true;
        if (this.generalWording === "") return true;
        if (this.accountingLines.find((line) => line.date <= line.bankAccount?.startAuthorizedDate))
            return true;
        return false;
    }

    close() {
        this.initialize();
        this.$emit("closeDialog");
    }

    // refreshKeyAccountableAccount = 0

    setAccountableAccount(item, data) {
        item.accountableAccount = JSON.parse(JSON.stringify(data.accountableAccount));
        if (item.user) {
            item.user = null;
        }
        if (item.bankAccount) {
            item.bankAccount = null;
        }
        if (item.thirdPartyCompany) {
            item.thirdPartyCompany = null;
        }
        if (data.thirdParty) {
            switch (data.thirdParty.type) {
                case "company":
                    item.thirdPartyCompany = data.thirdParty;
                    delete item.thirdPartyCompany.type;
                    break;
                case "user":
                    item.user = data.thirdParty;
                    delete item.user.type;
                    break;
                case "bankAccount":
                    item.bankAccount = data.thirdParty;
                    delete item.bankAccount.type;
                    break;
            }
        }

        if (data.accountableAccount.invoiceProduct) {
            if (item.stockOperation) {
                item.stockOperation.stockProduct = data.accountableAccount.invoiceProduct;
                item.stockOperation.tagId =
                    data.accountableAccount.invoiceProduct.tag?.id || undefined;
            } else {
                item.stockOperation = {
                    stockProduct: data.accountableAccount.invoiceProduct,
                    productQuantity: 0,
                    tagId: data.accountableAccount.invoiceProduct.tag?.id || undefined,
                };
            }
        } else {
            item.stockOperation = null;
        }

        item.paymentStatus = this.getPaymentStatus(item);
        // this.refreshKeyAccountableAccount++
    }

    tags = null;

    async onTagsChanged(data) {
        this.tags = data.tags;
        for (const tag of this.tags) {
            if (tag.primaryLog) {
                this.logTagId = tag.id;
                break;
            }
        }
    }

    onAccountingLineTagsChanged(data) {
        if (data.accountingLineId) {
            const al = this.accountingLines.find((al) => al.id === data.accountingLineId);
            if (al) {
                al.tags = data.tags;
            }
        }
    }

    get acccountingLinesHeaders() {
        const headers: Array<any> = [
            { text: "Date", value: "date", align: "center", sortable: true },
            { text: "Libellé", value: "wording", align: "center", sortable: false },
            { text: "Comptes", value: "accountableAccount", align: "center", sortable: false },
            { text: "Débit", value: "debit", align: "center", sortable: true },
            { text: "Crédit", value: "credit", align: "center", sortable: true },
        ];
        if (this.showDueDateColumn) {
            headers.push({ text: "Echéance", value: "dueDate", align: "center", sortable: true });
        }
        headers.push({ text: "Action", value: "", align: "center", sortable: false });
        return headers;
    }

    get freeTagColspan() {
        return this.showDueDateColumn ? 6 : 5;
    }

    modifyAutoCompletion() {
        this.autoCompletion = !this.autoCompletion;
    }

    // @Watch("accountingLines", {deep:true})
    // async onAccountingLinesChanged(){
    //     if (!this.autoCompletion) return
    //     if (this.documentId) return
    //     if (this.zTillReceiptId) return
    //     if (this.expenseReportId) return
    //     if (this.bankTransactionId) return
    //     if (this.type === "PURCHASE_INVOICE") {
    //         for (const al of this.accountingLines) {

    //         }
    //     }
    // }

    insertLineAfter(index: number) {
        const emptyRow = JSON.parse(JSON.stringify(this.emptyRow));
        this.accountingLines.splice(index + 1, 0, emptyRow);
        if (this.onAccountingLinesPage) {
            if (!this.accountingLines[index].wording) {
                this.accountingLines[index].wording = this.generalWording;
            }
            if (!this.accountingLines[index + 1].wording) {
                this.accountingLines[index + 1].wording = this.generalWording;
            }
        }
    }

    tabOnCredit(index: number) {
        if (this.onAccountingLinesPage && index === this.accountingLines.length - 1) {
            if (this.isBalanced) {
                this.$emit("add-item");
            } else {
                this.insertLineAfter(index);
            }
        }
    }

    removeItem() {
        this.$emit("remove-item");
    }

    removeLine(index: number) {
        if (this.onAccountingLinesPage) {
            if (this.accountingLines.length > 1) {
                this.accountingLines.splice(index, 1);
            } else {
                this.$emit("remove-item");
            }
        } else {
            this.accountingLines.splice(index, 1);
            if (this.accountingLines.length === 1) {
                this.insertLineAfter(0);
            }
        }
    }

    updateWording(wording) {
        this.generalWording = wording;
        for (const line of this.accountingLines) {
            line.wording = this.generalWording;
        }
    }

    tableElement: Element;

    beforeMount() {
        window.addEventListener("keydown", this.keyDownEvent);
        document.addEventListener("keyup", this.onKeyUp);
        this.tableElement = document.getElementById("oss-dense-table");
        if (this.onAccountingLinesPage) {
            emitter.$on("validate-item", this.valid);
        }
    }

    beforeDestroy() {
        window.removeEventListener("keydown", this.keyDownEvent);
        document.removeEventListener("keyup", this.onKeyUp);
        if (this.onAccountingLinesPage) {
            emitter.$off("validate-item", this.valid);
        }
    }

    tabIndexNextLine() {
        const item = document.activeElement;
        if (item.nextElementSibling) {
            this.activate(item.nextElementSibling);
        }
    }

    tabIndexPreviousLine() {
        const item = document.activeElement;
        if (item.previousElementSibling) {
            this.activate(item.previousElementSibling);
        }
    }

    activate(item) {
        // Set all of the buttons to tabindex -1
        if (this.tableElement) {
            this.tableElement.querySelectorAll("button").forEach((btn) => (btn.tabIndex = -1));

            // Make the current button "active"
            item.tabIndex = 0;
            item.focus();
        }
    }

    keyDownEvent(event: KeyboardEvent) {
        // up arrow
        if (event.keyCode === 38) {
            this.tabIndexPreviousLine();
        }
        // down arrow
        if (event.keyCode === 40) {
            this.tabIndexNextLine();
        }
    }

    // @Watch("accountingLines", { deep: true })
    // onAccountingLinesChanged() {
    //     this.$emit("input", this.accountingLines);
    // }

    @Watch("actions", { immediate: true })
    initActions() {
        if (this.actions?.action) {
            this.actions.action.function = this.valid;
            this.actions.action.title = "Valider";
            this.actions.action.disabled = () => this.disabledValidation;
            this.actions.action.dialogTitle = () =>
                (this.documentId ? "Edition : " : "Création : ") +
                this.$t("accountingItem.type." + this.type);
        }
    }

    @Watch("disabledValidation")
    updateItem() {
        if (this.disabledValidation && this.onAccountingLinesPage) {
            this.$emit("item-is-not-valid");
        }
    }

    resetAccountingLines() {
        this.accountingLines = cloneDeep(this.defaultRows);
    }

    @Watch("log")
    onLogChanged(value) {
        if (this.autoCompletion) {
            const aa = this.getAccountableAccount(value);
            if (!!aa) {
                this.resetAccountingLines();
                // while (this.accountingLines.length >=2)
                //     this.accountingLines.splice(1, this.accountingLines.length - 1)
                //     this.addEmptyAL(undefined)
                // }
                if (this.onAccountingLinesPage) {
                    // to make the autocompletion functional
                    this.insertLineAfter(0);
                    this.insertLineAfter(1);
                }
                if (this.accountingLines.length) {
                    // const elem:any = document.getElementById('line-aa-0')
                    // if (elem?.__vue__?.openDialog) {
                    //     elem.__vue__.openDialog()
                    // }
                    // @ts-ignore
                    if (this.$refs.line_0?.length) {
                        const firstLine = this.$refs.line_0[0];
                        // @ts-ignore
                        if (firstLine.$refs?.accountableAccount?.openDialog) {
                            // @ts-ignore
                            this.focusedElement.line = { index: 0, field: "accountableAccount" };
                            firstLine.$refs.accountableAccount?.openDialog(aa);
                        }
                    }
                }
            }
        }
    }

    focusOnDate() {
        const dateTabIndex = this.onAccountingLinesPage ? (this.editionIndex + 1) * 100 + 2 : "1";
        if (dateTabIndex) {
            const dateField = document.querySelector(`[tabindex="${dateTabIndex}"]`) as HTMLElement;
            if (dateField) {
                setTimeout(() => {
                    dateField.focus();
                }, 500);
            }
        }
    }

    focusOnWording(index: number) {
        const wordingTabIndex = this.onAccountingLinesPage
            ? (this.editionIndex + 1) * 100 + (index + 1) * 10 + 2
            : 7 * index + 2;
        if (wordingTabIndex) {
            const wordingField = document.querySelector(
                `[tabindex="${wordingTabIndex}"]`,
            ) as HTMLElement;
            if (wordingField) {
                setTimeout(() => {
                    wordingField.focus();
                }, 500);
            }
        }
    }

    async onKeyUp(ev) {
        const event = ev || window.event; // Event object 'ev'
        if (event) {
            const key = event.which || event.keyCode; // Detecting keyCode
            if (key) {
                if (key == 9) {
                    this.nextTab();
                    if (event.shiftKey) {
                        this.prevTab();
                    }
                }
            }
        }
    }

    nextTab() {
        if (this.autoCompletion && this.focusedElement) {
            if (this.focusedElement.line?.index !== undefined) {
                const refs = this.$refs["line_" + this.focusedElement.line.index];
                // @ts-ignore
                if (refs?.length) {
                    const line = refs[0];
                    line.nextFocus();
                }
            }
        }
    }

    prevTab() {
        if (this.autoCompletion && this.focusedElement) {
            if (this.focusedElement.line?.index !== undefined) {
                const refs = this.$refs["line_" + this.focusedElement.line.index];
                // @ts-ignore
                if (refs?.length) {
                    const line = refs[0];
                    line.previousFocus();
                }
            }
        }
    }

    focusedElement = {
        line: null,
    };
    onLineFocus(data) {
        this.focusedElement.line = data;
    }

    onNextLine(index) {
        let nextIndex = 0;
        if (index < 0) {
            nextIndex = 0;
        } else if (index + 1 < this.accountingLines.length) {
            nextIndex = index + 1;
        } else {
            nextIndex = 0;
        }
        this.focusedElement.line = { index: nextIndex, field: "accountableAccount" };
        this.nextTab();
    }

    onPreviousLine(index) {
        let previousIndex;
        if (index) {
            previousIndex = index - 1;
        } else if (this.accountingLines.length) {
            previousIndex = this.accountingLines.length - 1;
        }
        if (previousIndex !== undefined) {
            this.focusedElement.line = { index: previousIndex, field: "addLine" };
            this.prevTab();
        }
    }

    onTabOnDate() {
        // make autocompletion active on the created item
        if (
            this.onAccountingLinesPage &&
            this.log &&
            this.autoCompletion &&
            this.accountingLines.length &&
            !this.accountingLines[0].accountableAccount.name
        ) {
            const aa = this.getAccountableAccount(this.log);
            // @ts-ignore
            if (this.$refs.line_0?.length) {
                const firstLine = this.$refs.line_0[0];
                // @ts-ignore
                if (firstLine.$refs?.accountableAccount?.openDialog) {
                    // @ts-ignore
                    this.focusedElement.line = { index: 0, field: "accountableAccount" };
                    firstLine.$refs.accountableAccount?.openDialog(aa);
                }
            }
        }
    }

    @Apollo({
        query: VAT_DECLARATION_LAST,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return this.companyId === null || !this.autoCompletion || this.log !== "VAT";
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.lastDeclaration = null;
            if (!loading) {
                if (data) {
                    if (data.vatDeclarations && data.vatDeclarations.length) {
                        this.lastDeclaration = data.vatDeclarations[0];
                        if (
                            this.lastDeclaration.vatDocument &&
                            this.lastDeclaration.vatDocument.accountingLines &&
                            this.lastDeclaration.vatDocument.accountingLines.length
                        ) {
                            // this.rows = []
                            this.accountingLines = [];
                            for (const al of this.lastDeclaration.vatDocument.accountingLines) {
                                this.addEmptyAL(al.accountableAccount);
                                // this.addRow(al.accountableAccount, 0, 0)
                            }
                            if (this.accountingLines.length) {
                                this.focusedElement.line = {
                                    index: 0,
                                    field: "accountableAccount",
                                };
                                this.nextTab();
                            }
                        }
                    } else {
                        this.lastDeclaration = null;
                    }
                }
            }
        },
    })
    lastDeclaration: any = null;

    revert() {
        for (const al of this.accountingLines) {
            const credit = al.debit;
            al.debit = al.credit;
            al.credit = credit;
            al.amountSigned = al.debit || -al.credit;
        }
    }

    get enableDuplicate() {
        if (this.bankTransactionId || this.log === "BANK_TRANSACTION") {
            return false;
        }
        if (this.documentId || this.zTillReceiptId || this.expenseReportId) {
            return true;
        }
        return false;
    }

    duplicate() {
        debugger;
        if (this.enableDuplicate) {
            // this.documentId = "";
            // this.zTillReceiptId = "";
            // this.expenseReportId = "";
            this.duplicateAccountingTransaction = true;

            for (const al of this.accountingLines) {
                if (al.id) {
                    delete al.id;
                }
                if (al.documentId) {
                    delete al.documentId;
                }
                if (al.bankTransactionId) {
                    delete al.bankTransactionId;
                }
                if (al.reconciliation) {
                    delete al.reconciliation;
                }
                if (al.stockOperation) {
                    delete al.stockOperation;
                }
            }
        }
    }
}
